/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable security-node/detect-crlf */
/* eslint-disable max-len */
/* eslint-disable security-node/detect-crlf */
/* eslint-disable max-len */
/* eslint-disable security-node/detect-crlf */
/* eslint-disable max-len */

import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { HStack, Text, VStack } from '@chakra-ui/react'
import { useDisplayModal, useVehicles } from 'context'
import { VehicleCode, VehicleType } from 'context/Vehicles/vehiclesTypes'
import { CHECK_CARCODE_SCHEMA } from 'context/Vehicles/vehiclesValidations'
import { Formik } from 'formik'

import { CardBody, CardContainer } from 'components/CustomCard'
import { CustomModal } from 'components/CustomModal'
import {  PinInputControl, SubmitButton } from 'components/InputCustom'
import { customToast  } from 'components/ToastCustom'
import { VehiclePlateInfo } from 'components/VehiclePlateInfo'

export const AddVehicleWithCarCode = () => {
  const navigate = useNavigate()
  const [validationCode, setValidationCode] = useState<string>('')

  const { openDialog, closeModal } = useDisplayModal()
  const { addNewVehicle,addVehicleClearError, resetNewVehicleAdded,getVehicleByQrDeviceId, setVehicle, vehicleState: { loading,
    state: {  newVehicle, newVehicleAdded, addVehicleLoading, errorAddVehicle } } } = useVehicles()
  const initialValues: VehicleCode = {
    carCode: '',
  }

  const handleGoBack = () => {
    navigate('/my-vehicles')
  }

  const handleSuccess = (vehicle: VehicleType) => {
    openDialog({
      content: (
        <CustomModal
          title={'¡Felicitaciones!'}
          message={'Tu vehiculo ha sido ingresado con éxito'}
          primaryButton
          closeGoBackPress={() => {
            closeModal()
          }}
          vehicle={vehicle}
          closeAcceptPress={() => {
            closeModal()
            navigate('/my-vehicles')
          }}
          type='tertiary'
          />
      ),
      variant: 'tertiary',
    })
  }

  const handleSetQrDeviceId: (value: string) => void = async (
    value: string,
  ) => {
    try {
      const vehicle = await getVehicleByQrDeviceId(value)

      console.log(vehicle)

    } catch (error) {
      console.log(error)
    }
  }
  const handleOnSubmit = async (data: VehicleCode) => {
    addVehicleClearError()

    const newVehicle = await addNewVehicle(data.carCode || '')

    errorAddVehicle === ''

    if (newVehicle) {
      addVehicleClearError()
      resetNewVehicleAdded()
      await setVehicle(newVehicle)
      handleSuccess(newVehicle)
    }
  }

  useEffect(() => {
    console.log(errorAddVehicle)
    errorAddVehicle && customToast.showToast({ description: 'Ingresa nuevamente el código', title: 'Código incorrecto' })
    addVehicleClearError()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorAddVehicle])

  useEffect(() => {
    addVehicleClearError()

    if (validationCode.length === 6) {
      // setHaveVehicle(false)
      addVehicleClearError()
      resetNewVehicleAdded()
      handleSetQrDeviceId(validationCode.toLowerCase())
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newVehicleAdded, validationCode])

  return (
    <Formik
      enableReinitialize
      validateOnMount
      initialValues={initialValues}
      onSubmit={handleOnSubmit}
      validationSchema={CHECK_CARCODE_SCHEMA}>
      {({ values, isValid }) => (
        <CardContainer isScreen hiddenStack={false} onClose={handleGoBack} headerText={'Agrega tu vehículo'}>
          <CardBody>
            <VStack w={'full'} justifyContent={'center'} alignItems={'center'} spacing={6}>
              <Text textAlign={'center'} variant={{ base: 'SM', md: 'LG' }}>
                Ingresa tu código de activación
              </Text>
              <VStack w={'full'} spacing={6}>
                    <Text textAlign={'center'} variant={{ base: 'XS', md: 'MD' }}>
                    Ingresa el código de 6 dígitos que recibiste en tu correo, en la compra o instalación del dispositivo
                    </Text>
                    <PinInputControl
                      setValidationCode={setValidationCode}
                      pinAmount={6}
                      pinInputProps={{ mask: false, isDisabled: loading, type: 'alphanumeric' }}
                      name='carCode'
                      placeholder='INGRESAR CARCODE'
                      success={newVehicle !== null}
                      error={errorAddVehicle || ''}
                      label='' />
              </VStack>
              {newVehicle !== null && (
                          <HStack  alignItems={'center'} alignContent={'center'}>
                            <VehiclePlateInfo vehicle={newVehicle} direction={'row'} isCarrouselItem />
                          </HStack>
                        )}
              <SubmitButton
                disabled={(!(isValid && values.carCode.length > 5) || loading || errorAddVehicle !== '')}
                loadingText={'Buscando información...'}
                isLoading={loading || addVehicleLoading}
                mx={'auto'}>
                {newVehicle !== null ? 'Enlazar vehículo':'Ingresar vehículo'}
              </SubmitButton>
            </VStack>
          </CardBody>
        </CardContainer>
      )
      }
    </Formik >
  )
}
